export class NewsletterSubscribers {
    newsletterSubscriberId: string;
    emailId: string;
   
    constructor() {
        this.newsletterSubscriberId="";
        this.emailId="";
    }
}